export const Paths = {
  policy: '/policy',
  people: '/profiles',
  households: '/households',
  groups: '/groups',
  memberStatus: '/settings/profiles',
  tags: '/tags',
  comments: '/comments',
  reminders: '/reminders',
  mentions: '/mentions',
  milestones: '/milestones',
  metrics: '/metrics',
};
